import { Component, OnInit } from '@angular/core';
import { getPiiServiceId } from '../../shared/pii/pii.utils';
import {
  ApplicationState,
  getCyberCareProductsPrice,
  getProducts,
} from '../../store/reducers';
import { OnDestroyHookDirective } from '../../shared/hooks';
import { Store } from '@ngrx/store';
import { Option, Price, Product } from '@dch/products-business-logic';
import { GetCyberCareProductPrice } from '../store/actions/cyber-care.actions';
import * as ProductsActions from '../../store/actions/products.actions';
import { CyberCareCeaseModalComponent } from '../cyber-care-cease-modal/cyber-care-cease-modal.component';
import { ModalService } from '@proximus/ng-common-components';
import { buildTaggingProduct } from '../../tagging/tagging.utils';
import { InceptionService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-cyber-care-container',
  templateUrl: './cyber-care-container.component.html',
  styleUrls: ['./cyber-care-container.component.css'],
})
export class CyberCareContainerComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  title: string;
  serviceId: string;
  dataLoaded = false;
  fakeCyberCareOption: Option;
  jsonProduct: string;
  yearlyPrice: number;

  constructor(
    private store: Store<ApplicationState>,
    private modalService: ModalService,
    private inceptionService: InceptionService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.serviceId = getPiiServiceId();

    this.scrollToTop();

    this.addSubscription(
      this.store.select(getCyberCareProductsPrice).subscribe((price) => {
        if (
          price &&
          price.calculated_prices &&
          price.calculated_prices.length > 0
        ) {
          this.fakeCyberCareOption = this.buildFakeOption(
            price.calculated_prices[0],
          );
          this.yearlyPrice =
            this.fakeCyberCareOption.price.calculatedPriceVat * 12;
        }
      }),
    );

    this.addSubscription(
      this.store.select(getProducts).subscribe((products) => {
        if (products && products.length > 0 && !this.dataLoaded) {
          this.dataLoaded = true;
          const product = this.findProduct(products, this.serviceId);
          if (product) {
            this.title = product.productDescription;
            this.serviceId = product.accessNumber;
            this.jsonProduct = buildTaggingProduct(product);
          }
          this.store.dispatch(
            new GetCyberCareProductPrice({
              mpcUuid: product.groupMpcUuid,
              packMpcUuid: product.packMpcUuid,
              chargeConfiguration: product.chargeConfiguration,
            }),
          );
        }
      }),
    );
    this.store.dispatch(new ProductsActions.GetProducts());
  }

  public showCeasePopup() {
    this.modalService
      .create<CyberCareCeaseModalComponent>(CyberCareCeaseModalComponent)
      .subscribe((componentRef) => {});
  }

  private findProduct(products: Array<Product>, serviceId: string) {
    const filteredProducts =
      serviceId &&
      products.filter((product) => serviceId === product.accessNumber);
    if (filteredProducts && filteredProducts.length > 0) {
      return filteredProducts[0];
    }
    return undefined;
  }

  private buildFakeOption(price: any) {
    return {
      hideIncludedLabel: true,
      price: {
        calculatedPriceNoVat: price.calculated_price_no_vat,
        calculatedPriceVat: price.calculated_price_vat,
        priceNoVat: price.price_no_vat,
        priceVat: price.price_vat,
        chargeFrequency: price.charge_frequency,
      } as Price,
    } as Option;
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#cybercareDetails');
    });
  }
}
